import { render } from "./AddContactorView.vue?vue&type=template&id=5d9e2a98&scoped=true"
import script from "./AddContactorView.vue?vue&type=script&lang=js"
export * from "./AddContactorView.vue?vue&type=script&lang=js"

import "./AddContactorView.vue?vue&type=style&index=0&id=5d9e2a98&lang=scss&scoped=true"

import exportComponent from "/Users/icesea/WebstormProjects/fpcs-h5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d9e2a98"]])

export default __exports__